<script setup lang="ts">
const props = defineProps<{
  multiple?: boolean,
}>()

const activeId = ref<string | string[] | null>(props.multiple ? [] : null)

const updateModelValue = (value: any | null) => {
  activeId.value = value
}
</script>

<template>
  <AccordionRoot
    :type="multiple ? 'multiple' : 'single'"
    :default-value="multiple ? [] : undefined"
    :collapsible="true"
    @update:modelValue="updateModelValue"
  >
    <slot name="content" :activeId="activeId" />
  </AccordionRoot>
</template>
